import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";

interface Props {
  open: boolean;
  providerName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DisconnectDialog(props: Props) {
  const { open, providerName, onCancel, onConfirm } = props;
  const { t } = useTranslation("storage");
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      classes={{ paper: classes.paper }}
      data-testid="external-ai__disconnect-dialog"
    >
      <DialogTitle className={classes.title}>
        {t("externalAI.disconnect.title", { provider: providerName })}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText variant="body2" className={classes.text}>
          {t("externalAI.disconnect.message")}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          color="primary"
          onClick={onCancel}
          data-testid="external-ai__disconnect-cancel"
        >
          {t("common:cancel")}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disableElevation
          onClick={onConfirm}
          data-testid="external-ai__disconnect-confirm"
        >
          {t("externalAI.disconnect.button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles({
  paper: { maxWidth: 460 },
  title: {
    padding: "22px 24px 10px",
    "& h2": { fontSize: 18 },
  },
  content: { padding: "0 24px" },
  text: { marginBottom: 0, color: "rgba(0, 0, 0, 0.7)" },
  actions: { padding: "20px 24px 14px" },
});
